var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406 31h-60-60c-57.891 0-106 47.109-106 105 0 52.808 40.185 96.636 91 103.931v46.069c0 6.064 3.647 11.543 9.258 13.857 5.533 2.309 12.023 1.071 16.348-3.252l49.394-49.394 6.211-6.211h53.789c57.891 0 106-47.109 106-105s-48.109-105-106-105z",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 241c57.891 0 106-47.109 106-105s-48.109-105-106-105h-60v216.211l6.211-6.211z",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 376v60c0 26.1-21.31 45-44.79 45-86.41 0-170.71-40.85-233.41-103.3s-103.8-146.5-103.8-232.91c0-24.82 20.19-44.79 45-44.79h60c6.46 0 12.19 4.13 14.22 10.25l30 89.79c1.47 4.4.82 9.22-1.74 13.07l-25.44 38.17c9.64 20.22 26.7 42.32 46.4 61.78 19.71 19.45 42.06 36.26 62.28 45.9l38.17-25.44c3.87-2.55 8.67-3.22 13.07-1.74l90 30c6.12 2.03 10.04 7.76 10.04 14.22z",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 376v60c0 26.1-21.31 45-44.79 45-86.41 0-170.71-40.85-233.41-103.3l64.64-64.64c19.71 19.45 42.06 36.26 62.28 45.9l38.17-25.44c3.87-2.55 8.67-3.22 13.07-1.74l90 30c6.12 2.03 10.04 7.76 10.04 14.22z",
    fill: "#f03800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.999,
    cy: 135.999,
    fill: "#613d5c",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 135.998,
    fill: "#613d5c",
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4b2746"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m361 135.998c0-8.284-6.716-15-15-15v30c8.284 0 15-6.716 15-15z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.999,
    cy: 135.999,
    r: 15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d017e1ae418c694ba9148c0a9001609c.svg";
export { ForwardRef as ReactComponent };